import React, { FC } from 'react';

import { Modal } from 'components/molecules/modal';

import { TEXTS } from './config';

interface DeleteTaskModalProps {
  onSubmitClick: () => void;
  onCancelClick: () => void;
  isVisible: boolean;
}

export const DeleteTaskModal: FC<DeleteTaskModalProps> = ({
  onSubmitClick,
  onCancelClick,
  isVisible,
}) => (
  <Modal
    label={TEXTS.DELETE_TASK_MODAL.LABEL}
    isVisible={isVisible}
    withTopButtonsMargin
    closeConfig={{ onClick: onCancelClick }}
    submitConfig={{
      isDanger: true,
      label: TEXTS.DELETE_TASK_MODAL.SUBMIT_LABEL,
      onClick: onSubmitClick,
    }}
    rejectConfig={{
      label: TEXTS.DELETE_TASK_MODAL.CANCEL_LABEL,
      onClick: onCancelClick,
    }}
  >
    <p style={{ fontSize: '1.6rem' }}>{TEXTS.DELETE_TASK_MODAL.MESSAGE1}</p>
  </Modal>
);
